import { render } from "./AccountSelector.vue?vue&type=template&id=346b773e&scoped=true&ts=true"
import script from "./AccountSelector.vue?vue&type=script&lang=ts"
export * from "./AccountSelector.vue?vue&type=script&lang=ts"

import "./AccountSelector.vue?vue&type=style&index=0&id=346b773e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346b773e"]])

export default __exports__